<template>
  <div class="popUpWrap">
    <section class="popup light planUpgrade" style="max-width: 560px;">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close"></div>
      </div>
      <div class="scrollY">
        <div class="infoBoxWrap">
          <form class="checkout-form flex col gap-16" @submit.prevent>
            <div class="upgradeHeading">
              <h5>{{ t('organization-subscription-upgrade-plan') }}</h5>
              <p>{{ t('organization-subscription-upgrade-plan-immediately-applied') }}</p>
            </div>

            <div class="changePlan flex gap-4">
              <div class="boxArea">
                <div class="titleArea">
                  <p>{{ t('pricing-current-plan') }}</p>
                  <h5>{{ props.currentPlanName }}</h5>
                </div>
              </div>
              <div class="boxArea highlight">
                <div class="titleArea">
                  <p>{{ t('organization-subscription-change-billing-cycle-description-1') }}</p>
                  <h5>{{ props.newPlanName }}</h5>
                </div>
              </div>
              <div class="changePlanArrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect width="24" height="24" rx="12" fill="#1B5EE0"/>
                  <path d="M13.5 15.5L17 12L13.5 8.5M17 12H7" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
                </svg>
              </div>
            </div>

            <template v-if="props.subscriptionDiffAmount">
              <div class="bar" />

              <fieldset class="checkout-form__section flex col gap-16">
                <legend class="v-hidden">{{ t('organization-subscription-upgrade-settlement-details') }}</legend>
                <h5 class="settlementTitle">{{ t('organization-subscription-upgrade-settlement-details') }}</h5>

                <dl class="settlementList flex col gap-6">
                  <div class="settlementList__item flex item-center justify-between gap-16">
                    <dt class="settlementList__label flex item-center gap-6">
                      {{ subscriptionDiffLabel.title }}
                      <span class="settlementList__divider" aria-hidden="true" />
                      <span class="label label--round settlementList__chip">{{ subscriptionDiffLabel.chip }}</span>
                    </dt>
                    <dd class="settlementList__value flex item-center gap-4">
                      {{ props.subscriptionDiffAmount }}
                      <span class="tooltipWrap">
                        <button
                            type="button"
                            class="icQuestion"
                            @mouseenter="isSubscriptionDiffTooltipOpen = true"
                            @mouseleave="isSubscriptionDiffTooltipOpen = false"
                            :aria-label="t('organization-subscription-upgrade-subscription-fee-difference', { date: props.remainingDays })"
                            @focus="isSubscriptionDiffTooltipOpen = true"
                            @blur="isSubscriptionDiffTooltipOpen = false"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <circle class="icQuestion__bg" cx="9" cy="9" r="9" fill="#414A66" fill-opacity="0.08"/>
                            <circle class="icQuestion__ring" cx="9" cy="9" r="8.5" stroke="#414A66" stroke-opacity="0.3"/>
                            <path class="icQuestion__glyph" d="M6.16722 6.6284C6.16576 6.66318 6.17137 6.69789 6.18372 6.73041C6.19607 6.76292 6.2149 6.79254 6.23904 6.81746C6.26318 6.84237 6.29213 6.86205 6.3241 6.87529C6.35608 6.88852 6.3904 6.89503 6.42496 6.89441H7.30728C7.45487 6.89441 7.57251 6.77271 7.59176 6.62517C7.68802 5.9187 8.16928 5.40392 9.027 5.40392C9.76066 5.40392 10.4323 5.77331 10.4323 6.66179C10.4323 7.34565 10.0323 7.66012 9.40025 8.13828C8.68049 8.66491 8.11046 9.27984 8.1511 10.2782L8.15431 10.5119C8.15543 10.5825 8.18409 10.6499 8.23411 10.6995C8.28413 10.749 8.3515 10.7768 8.42168 10.7768H9.28902C9.35993 10.7768 9.42794 10.7484 9.47808 10.6979C9.52822 10.6474 9.55639 10.579 9.55639 10.5076V10.3945C9.55639 9.62124 9.84836 9.39615 10.6366 8.79414C11.2879 8.29552 11.967 7.74197 11.967 6.57994C11.967 4.95267 10.6023 4.1665 9.10828 4.1665C7.75325 4.1665 6.26882 4.8019 6.16722 6.6284ZM7.83239 12.8348C7.83239 13.4089 8.28692 13.8332 8.91257 13.8332C9.56388 13.8332 10.012 13.4089 10.012 12.8348C10.012 12.2404 9.56281 11.8225 8.9115 11.8225C8.28692 11.8225 7.83239 12.2404 7.83239 12.8348Z" fill="#4E5566" fill-opacity="0.9"/>
                          </svg>
                        </button>
                        <div v-if="isSubscriptionDiffTooltipOpen" class="tooltipBox" role="tooltip">
                          <div class="tooltipBox__section">
                            <div class="tooltipBox__row">
                              <p class="tooltipBox__label">{{ t('organization-subscription-upgrade-pro-remaining-amount') }}</p>
                              <p class="tooltipBox__amount tooltipBox__amount--positive">{{ props.targetProratedAmountFormatted }}</p>
                            </div>
                            <p class="tooltipBox__formula">{{ proratedFormula(props.targetPlanPriceFormatted) }}</p>
                          </div>
                          <span class="tooltipBox__divider" />
                          <div class="tooltipBox__section">
                            <div class="tooltipBox__row">
                              <p class="tooltipBox__label">{{ t('organization-subscription-upgrade-basic-unused-deduction') }}</p>
                              <p class="tooltipBox__amount tooltipBox__amount--negative">-{{ props.currentUnusedAmountFormatted }}</p>
                            </div>
                            <p class="tooltipBox__formula">{{ proratedFormula(props.currentPlanPriceFormatted) }}</p>
                          </div>
                          <span class="tooltipBox__divider" />
                          <div class="tooltipBox__section">
                            <div class="tooltipBox__row tooltipBox__row--total">
                              <p class="tooltipBox__label tooltipBox__label--total">{{ t('organization-subscription-upgrade-difference') }}</p>
                              <p class="tooltipBox__amount tooltipBox__amount--total">{{ props.subscriptionDiffAmount }}</p>
                            </div>
                            <p class="tooltipBox__formula">{{ props.targetProratedAmountFormatted }} - {{ props.currentUnusedAmountFormatted }}</p>
                          </div>
                        </div>
                      </span>
                    </dd>
                  </div>

                  <div v-if="props.hasChargedCredit" class="settlementList__item flex item-center justify-between gap-16">
                    <dt class="settlementList__label flex item-center gap-6">
                      {{ creditDiffLabel.title }}
                      <span class="settlementList__divider" aria-hidden="true" />
                      <span class="label label--round settlementList__chip">{{ creditDiffLabel.chip }}</span>
                    </dt>
                    <dd class="settlementList__value flex item-center gap-4">
                      {{ props.chargedCreditDiffAmount }}
                      <span class="tooltipWrap">
                        <button
                            type="button"
                            class="icQuestion"
                            @mouseenter="isCreditDiffTooltipOpen = true"
                            @mouseleave="isCreditDiffTooltipOpen = false"
                            :aria-label="t('organization-subscription-upgrade-credit-unit-price-difference', { count: props.chargedCreditCount })"
                            @focus="isCreditDiffTooltipOpen = true"
                            @blur="isCreditDiffTooltipOpen = false"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <circle class="icQuestion__bg" cx="9" cy="9" r="9" fill="#414A66" fill-opacity="0.08"/>
                            <circle class="icQuestion__ring" cx="9" cy="9" r="8.5" stroke="#414A66" stroke-opacity="0.3"/>
                            <path class="icQuestion__glyph" d="M6.16722 6.6284C6.16576 6.66318 6.17137 6.69789 6.18372 6.73041C6.19607 6.76292 6.2149 6.79254 6.23904 6.81746C6.26318 6.84237 6.29213 6.86205 6.3241 6.87529C6.35608 6.88852 6.3904 6.89503 6.42496 6.89441H7.30728C7.45487 6.89441 7.57251 6.77271 7.59176 6.62517C7.68802 5.9187 8.16928 5.40392 9.027 5.40392C9.76066 5.40392 10.4323 5.77331 10.4323 6.66179C10.4323 7.34565 10.0323 7.66012 9.40025 8.13828C8.68049 8.66491 8.11046 9.27984 8.1511 10.2782L8.15431 10.5119C8.15543 10.5825 8.18409 10.6499 8.23411 10.6995C8.28413 10.749 8.3515 10.7768 8.42168 10.7768H9.28902C9.35993 10.7768 9.42794 10.7484 9.47808 10.6979C9.52822 10.6474 9.55639 10.579 9.55639 10.5076V10.3945C9.55639 9.62124 9.84836 9.39615 10.6366 8.79414C11.2879 8.29552 11.967 7.74197 11.967 6.57994C11.967 4.95267 10.6023 4.1665 9.10828 4.1665C7.75325 4.1665 6.26882 4.8019 6.16722 6.6284ZM7.83239 12.8348C7.83239 13.4089 8.28692 13.8332 8.91257 13.8332C9.56388 13.8332 10.012 13.4089 10.012 12.8348C10.012 12.2404 9.56281 11.8225 8.9115 11.8225C8.28692 11.8225 7.83239 12.2404 7.83239 12.8348Z" fill="#4E5566" fill-opacity="0.9"/>
                          </svg>
                        </button>
                        <div v-if="isCreditDiffTooltipOpen" class="tooltipBox tooltipBox--below" role="tooltip">
                          <p class="tooltipBox__description">{{ t('organization-subscription-upgrade-credit-difference-tooltip') }}</p>
                          <span class="tooltipBox__divider" />
                          <div class="tooltipBox__section">
                            <div class="tooltipBox__row tooltipBox__row--total">
                              <p class="tooltipBox__label tooltipBox__label--total">{{ t('organization-subscription-upgrade-difference') }}</p>
                              <p class="tooltipBox__amount tooltipBox__amount--total">{{ props.chargedCreditDiffAmount }}</p>
                            </div>
                            <p class="tooltipBox__formula">{{ creditDiffFormula }}</p>
                          </div>
                        </div>
                      </span>
                    </dd>
                  </div>

                  <div v-if="props.hasChargedCredit" class="settlementList__item discount flex item-center justify-between gap-16">
                    <dt class="settlementList__label">{{ splitParenthesis(t('organization-subscription-upgrade-support-discount')).title }}</dt>
                    <dd class="settlementList__value">- {{ props.upgradeSupportDiscountAmount }}</dd>
                  </div>
                </dl>
              </fieldset>

              <div class="bar" />


              <div class="payment-total flex col">
                <div class="payment-total__row flex item-center justify-between gap-16">
                  <strong class="payment-total__label">{{ t('payment-estimated-payment-amount') }}</strong>
                  <strong class="payment-total__amount">{{ props.estimatedAmount }}</strong>
                </div>
                <p v-if="props.isStripePayment" class="payment-total__tax">{{ t('payment-tax-description') }}</p>
              </div>

              <div class="bar" />
            </template>

            <div class="p-box">
              <div class="checkout-form__notice">
                <ul class="listDot">
                  <li v-if="props.hasChargedCredit">{{ t('organization-subscription-upgrade-description-1', { count: props.chargedCreditCount }) }}</li>
                  <li>{{ t('organization-subscription-upgrade-description-2') }}</li>
                  <li>
                    <i18n-t keypath="credit-history-top-up-credits-description-2">
                      <template #link>
                        <a class="linkTxt" target="_blank" href="/settings/org?tab=PAYMENT">
                          {{ t('organization-subscription-management') }}
                        </a>
                      </template>
                    </i18n-t>
                  </li>
                </ul>
              </div>
            </div>

            <div class="checkout-form__agreement">
              <ul>
                <li>
                  <input id="plan-upgrade-agreement" type="checkbox" name="agreement" v-model="isAgreed">
                  <label for="plan-upgrade-agreement">
                    <i18n-t keypath="organization-subscription-upgrade-agree-check">
                      <template #term>
                        <a class="linkTxt" target="_blank" href="/policy?tab=0">{{ t('common-terms-of-use') }}</a>
                      </template>
                    </i18n-t>
                  </label>
                </li>
              </ul>
            </div>
          </form>
        </div>

        <div class="btnArea">
          <LazySafetyRequestButton
            tag="button"
            type="button"
            class="btn"
            :class="{ disabled: !isAgreed }"
            :safety-click="onClickConfirmPayment"
          >
            {{ t('credit-history-top-up-credits-make-payment') }}
          </LazySafetyRequestButton>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDialogStore } from '~/store/dialog/dialogStore';

const { t, locale } = useI18n();
const dialogStore = useDialogStore();

const props = computed(() => {
  const dialogProps = dialogStore.options.props ?? {};
  return {
    currentPlanName: dialogProps.currentPlanName ?? '',
    newPlanName: dialogProps.newPlanName ?? '',
    remainingDays: dialogProps.remainingDays ?? 0,
    subscriptionDiffAmount: dialogProps.subscriptionDiffAmount ?? '',
    targetProratedAmountFormatted: dialogProps.targetProratedAmountFormatted ?? '',
    currentUnusedAmountFormatted: dialogProps.currentUnusedAmountFormatted ?? '',
    targetPlanPriceFormatted: dialogProps.targetPlanPriceFormatted ?? '',
    currentPlanPriceFormatted: dialogProps.currentPlanPriceFormatted ?? '',
    totalCycleDays: dialogProps.totalCycleDays ?? 0,
    hasChargedCredit: dialogProps.hasChargedCredit ?? false,
    chargedCreditCount: dialogProps.chargedCreditCount ?? 0,
    chargedCreditDiffAmount: dialogProps.chargedCreditDiffAmount ?? '',
    upgradeSupportDiscountAmount: dialogProps.upgradeSupportDiscountAmount ?? '',
    currentTierName: dialogProps.currentTierName ?? '',
    targetTierName: dialogProps.targetTierName ?? '',
    currentCreditUnitPriceFormatted: dialogProps.currentCreditUnitPriceFormatted ?? '',
    targetCreditUnitPriceFormatted: dialogProps.targetCreditUnitPriceFormatted ?? '',
    estimatedAmount: dialogProps.estimatedAmount ?? '',
    isStripePayment: dialogProps.isStripePayment ?? false,
  };
})

const isAgreed = ref(false)

// locale 문구는 번역 시트와 동기화되므로 새 키를 만들지 않는다. 기존 문구를 화면에서 조합한다 (REQ-409·416·418).
// "구독료 차액 (잔여 210일)" → 제목 "구독료 차액" + 라벨 "잔여 210일". 일본어 전각 괄호도 처리한다.
const splitParenthesis = (text: string) => {
  const matched = text.match(/^(.*?)\s*[(（]([^()（）]*)[)）]\s*$/)
  return matched ? { title: matched[1], chip: matched[2] } : { title: text, chip: '' }
}

const subscriptionDiffLabel = computed(() =>
  splitParenthesis(t('organization-subscription-upgrade-subscription-fee-difference', { date: props.value.remainingDays })))
const creditDiffLabel = computed(() =>
  splitParenthesis(t('organization-subscription-upgrade-credit-unit-price-difference', { count: props.value.chargedCreditCount })))

// 일수 단위("365일", "365 days")는 브라우저 Intl 로 만든다.
const formatDays = (days: number) =>
  new Intl.NumberFormat(locale.value, { style: 'unit', unit: 'day', unitDisplay: 'long' }).format(days)

// 잔여분 계산식: 플랜 가격 × 잔여일 / 주기 전체 일수 (REQ-416)
const proratedFormula = (planPrice: string) =>
  `${planPrice} × ${props.value.remainingDays} / ${formatDays(props.value.totalCycleDays)}`

// 크레딧 단가 차액 계산식: (프로 단가 - 현재 플랜 단가) × 보유 충전 크레딧 수 (REQ-418)
const creditDiffFormula = computed(() => {
  const { targetTierName, targetCreditUnitPriceFormatted, currentTierName, currentCreditUnitPriceFormatted, chargedCreditCount } = props.value
  const heldCredits = t('organization-subscription-upgrade-held-credit-count', { count: chargedCreditCount }, chargedCreditCount)
  return `(${targetTierName} ${targetCreditUnitPriceFormatted} - ${currentTierName} ${currentCreditUnitPriceFormatted}) x ${heldCredits}`
})

const isSubscriptionDiffTooltipOpen = ref(false)
const isCreditDiffTooltipOpen = ref(false)

const onClickConfirmPayment = () => {
  if (!isAgreed.value) return
  dialogStore.close()
  dialogStore.options.confirm?.event()
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/abstracts/variables.scss";

.upgradeHeading{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;

  h5{
    margin: 0;
  }
  p{
    margin: 0;
    color: $color-txt-d-2;
    font-size: 14px;
  }
}

.changePlan{
  position: relative;

  .boxArea{
    flex: 1;
    padding: 16px;
    border-radius: 6px;
    border: 1px solid $color-line-l-10;
    background: #F7F9FC;
    text-align: center;

    &.highlight{
      background: rgba(26, 97, 234, 0.1);
    }

    .titleArea{
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;

      p{
        margin: 0;
        font-size: 14px;
        line-height: 22px;
        color: $color-txt-d-2;
      }
      h5{
        margin: 0;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  &Arrow{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
    line-height: 0;
  }
}

.bar{
  background: rgba(24, 54, 122, 0.15);
}

// 공통 팝업은 transform: translate(-50%, -50%) 로 가운데 정렬한다. 팝업 높이가 홀수·소수점이면
// 좌표가 0.5px 단위로 떨어져 테두리와 가로 라인이 흐려진다. 이 팝업은 transform 없이 가운데 정렬한다 (REQ-409).
.popup.light.planUpgrade{
  inset: 0;
  margin: auto;
  height: fit-content;
  transform: none;
}

// .popup.light h5 (18px, margin-bottom 8px) 를 이겨야 기획 값(16px, 내용과 간격 16px)이 적용된다.
.popup.light .settlementTitle{
  min-height: 0;
  margin: 0;
  font-size: 16px;
  line-height: 18px;
}

.settlementList{
  &__label{
    font-size: 14px;
    font-weight: 500;
    color: $color-txt-l-3;
    white-space: nowrap;
  }

  &__value{
    font-size: 14px;
    font-weight: 600;
    color: $color-txt-d-1;
    white-space: nowrap;
  }

  &__divider{
    width: 1px;
    height: 10px;
    background: $color-line-l-10;
  }

  &__chip{
    padding: 2px 8px;
    border: 1px solid $color-line-l-10;
    background: #F7F9FC;
    color: $color-txt-d-2;
  }

  &__item.discount{
    .settlementList__label, .settlementList__value{
      color: #CA3D3D;
      font-weight: 600;
      font-size: 14px;
    }
  }
}

.tooltipWrap{
  position: relative;
  display: inline-flex;
  // 오른쪽에 보이지 않는 여백을 둬서, Figma 고정값(arrow right:12px)이
  // 18px 아이콘 중앙(9px)과 겹치도록 기준 박스를 7px 더 넓힘
  padding-right: 7px;
}

.icQuestion{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 100%;
  background-color: transparent;
  cursor: pointer;

  &:hover, &:focus-visible{
    .icQuestion__bg{
      fill-opacity: 0.8;
    }
    .icQuestion__ring{
      stroke-opacity: 0.5;
    }
    .icQuestion__glyph{
      fill: $color-white;
      fill-opacity: 1;
    }
  }
}

.tooltipBox{
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 320px;
  box-sizing: border-box;
  padding: 16px;
  border-radius: 6px;
  background: #414A66;
  color: $color-white;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  white-space: pre-line;
  text-align: left;
  box-shadow: 0 4px 8px 0 rgba(80, 95, 153, 0.12);

  &::after{
    content: "";
    position: absolute;
    bottom: -4px;
    right: 12px;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #414A66;
  }

  &--below{
    bottom: auto;
    top: calc(100% + 8px);

    &::after{
      top: -4px;
      bottom: auto;
      border-top: none;
      border-bottom: 4px solid #414A66;
    }
  }

  &__section{
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  &__divider{
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
  }

  &__row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
  }

  &__label{
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px !important;
    color: $color-white;

    &--total{
      font-size: 14px;
      line-height: 16px !important;
    }
  }

  &__amount{
    margin: 0;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px !important;
    white-space: nowrap;

    &--positive{
      color: #B2CCFF;
    }
    &--negative{
      color: #FFB7B7;
    }
    &--total{
      font-size: 14px;
      line-height: 16px !important;
      color: $color-white;
    }
  }

  // Figma 2691:81728 계산방식: BTN/12-Semibold, rgba(255,255,255,0.75)
  &__formula{
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px !important;
    color: rgba(255, 255, 255, 0.75);
  }

  &__description{
    margin: 0;
    width: 100%;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px !important;
    color: #F0F3FA;
  }
}

.checkout-form__agreement label{
  font-weight: 600;
}

.btnArea{
  margin-top: 24px;
}
</style>
